import { render } from "./Profile.vue?vue&type=template&id=95fdbfb6&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=95fdbfb6&scoped=true&lang=css"

import exportComponent from "/var/www/compare-loans.org/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95fdbfb6"]])

export default __exports__